import { render, staticRenderFns } from "./safe-addpoint.vue?vue&type=template&id=303a45ae&scoped=true&"
import script from "./safe-addpoint.vue?vue&type=script&lang=js&"
export * from "./safe-addpoint.vue?vue&type=script&lang=js&"
import style0 from "./safe-addpoint.vue?vue&type=style&index=0&id=303a45ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303a45ae",
  null
  
)

export default component.exports